/**
 * Notification Service
 * Provides toast notifications that can be used outside React components (e.g., Axios interceptors)
 */

import { enqueueSnackbar, VariantType } from 'notistack';

// ============================================
// Notification Service Functions
// ============================================

export const notificationService = {
  success: (message: string) => {
    enqueueSnackbar(message, { variant: 'success' });
  },

  error: (message: string) => {
    enqueueSnackbar(message, { variant: 'error' });
  },

  info: (message: string) => {
    enqueueSnackbar(message, { variant: 'info' });
  },

  warning: (message: string) => {
    enqueueSnackbar(message, { variant: 'warning' });
  },

  toast: (message: string, variant: VariantType = 'default') => {
    enqueueSnackbar(message, { variant });
  },
};
